import { render, staticRenderFns } from "./payment-file-datatable.component.vue?vue&type=template&id=199fced6&scoped=true&"
import script from "./payment-file-datatable.component.vue?vue&type=script&lang=ts&"
export * from "./payment-file-datatable.component.vue?vue&type=script&lang=ts&"
import style0 from "./payment-file-datatable.component.vue?vue&type=style&index=0&id=199fced6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199fced6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
